export default __webpack_public_path__ + "static/media/62.f35ce018.png";